<template>
  <div class="row justify-content-md-center">
    <div class="col-md-6 col-lg-5 col-12">
      <b-card no-body class="checkin-screen">
        <check-in-header />
        <navigation-bar v-if="step" :active="step" />
        <b-card-body class="checkin-screen-body">
          <b-card-title v-if="title">{{ title }}</b-card-title>
          <slot />
        </b-card-body>
        <b-card-footer v-if="$slots.footer" class="p-0 checkin-sticky-bottom">
          <slot name="footer" />
        </b-card-footer>
      </b-card>
    </div>
    <loading-overlay :active="loading" :is-full-page="true" />
    <slot name="modals" />
  </div>
</template>

<script>
import CheckInHeader from '@/components/header/CheckInHeader'
import NavigationBar from '@/components/bodycard/navigationbar'

export default {
  name: 'CheckInScreen',
  components: {
    CheckInHeader,
    NavigationBar,
  },
  props: {
    title: { type: String, default: '' },
    step: { type: Number, default: null },
    loading: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.checkin-screen {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.checkin-screen-body {
  flex: 1 1 auto;
}
</style>
